<div class="one-morning" *ngIf="employer">
	<section class="hero">
		<div class="hero-img"><h2>You are so much <em>more</em> than your job.</h2></div>
	</section>

	<section class="well-being">
		<div class="copy fade-in">
			<div class="pre-headline">Support for Lifes Challenges</div>
			<div class="headline">Mental health doesn't discriminate between life and work.</div>
			<div class="text">Everybody is dealing with something&mdash;life on life's terms can be lonely, drive fear, and can paralyze us.  Calls for help hide behind a smile.  Mental health conditions and substance use disorders are biological brain disorders, not issues of willpower, character or intelligence.  Hope is what we do.</div>
		</div>
	</section>


	<section class="video">
		<video poster="/assets/images/learn_more_video_poster.png" controls [interact]="{engagementTypeID: 1, resource: 'Learn More Hero Video'}">
			<source [src]="env.learnMoreVideoURL" type="video/mp4">
		</video>
	</section>

	<div class="sunrise">
		<section class="topics fade-in" *ngIf="topicCardsToShow">
			<div class="pre-headline">You don't have to struggle alone.</div>
			<div class="headline">Just because you can handle it,<br/>doesn't mean you should.</div>
			<ng-container *ngIf="content[3] as data">
				<a class="cta" [href]="data['URL']" target="_blank" [interact]="{engagementTypeID: 4, resource: 'Visit Your EAP - Learn More'}">Visit Your EAP</a>
			</ng-container>
			<div class="topic-cards">
				<div *ngFor="let card of topicCardsToShow"><app-topic-card [cardData]="card"></app-topic-card></div>
			</div>
			<div class="load-more-holder">
				<div class="load more" (click)="loadMore()" *ngIf="topicCardsToShow?.length < topicCards?.length">Load More</div>
				<div class="load less" (click)="showLess()" *ngIf="topicCardsToShow?.length == topicCards?.length">Show Less</div>
			</div>
		</section>
	</div>

	<section class="assessment fade-in">
		<div class="copy">
			<div class="headline">Check in on your mental health.</div>
			<div class="text">Not sure where to start? These national mental health assessments provide a quick snapshot of your well-being, helping you recognize patterns and opening the door to deeper conversations with a trusted individual or health provider.</div>
			<div class="actions">
				<a class="cta" href="https://screening.mhanational.org/screening-tools/" target="_blank" [interact]="{engagementTypeID: 4, resource: 'Take An Assessment'}">Take an Assessment</a>
			</div>
		</div>
		<div class="img"></div>
	</section>

	<app-crisis-cards-section *ngIf="content[2]" [data]="content[2]"></app-crisis-cards-section>

	<section class="faqs fade-in">
		<div class="headline">FAQ</div>
		<ul class="faq-list">
			<li>
				<app-faq [question]="'How is One Morning different from my Employee Assistance Program (EAP)?'" [index]="1">
					<p>One Morning is here to complement your Employee Assistance Program (EAP) by making it easier for you to connect with the mental health resources you already have access to.</p>
					<p>Think of us as your friendly guide, here to help you find your way to the support you need. Although we’re not therapists, we can point you toward licensed counselors through your EAP. Remember, your EAP isn’t just for crisis situations. Talk through everyday solutions for everyday problems—24/7.</p>
					<p>Together with your organization, we believe in creating a healthier, more supportive workplace where everyone can thrive both in and out of work.</p>
				</app-faq>
			</li>
			<li>
				<app-faq [question]="'What does it cost?'" [index]="2">
					<p>Your EAP services are confidential and, in most cases, completely free to you, covered by your employer as part of your benefits package. This means you can access several sessions with a licensed counselor and other mental health resources without worrying about the cost. Curious about how many sessions you’re eligible for or what’s included? Check out our <a [routerLink]="['/learn-more']">Learn More page</a> for further details.</p>
				</app-faq>
			</li>
			<li>
				<app-faq [question]="'How do I access my EAP?'" [index]="3">
					<p>Getting the help you need is a phone call, text, or click away. You can visit the website, call or text their toll-free phone number, or download the app from your app store. If you’re not sure where to start, One Morning can help point you in the right direction; reach out to the contact info below.</p>
				</app-faq>
			</li>
			<li>
				<app-faq [question]="'I\'m in!  How can I be an advocate in my organization?'" [index]="4">
					<p>Advocacy starts with small, meaningful actions. Here are a few ways you can help make a difference:</p>
					<ul class="disc">
						<li><b>Share Your Story:</b> Personal stories can be powerful in encouraging others to seek help. If you’ve had a positive experience with One Morning, your EAP, or simply want to share your personal story, consider sharing it with your colleagues.  Want to share it with our One Morning team? Contact us at <a href="mailto:hello@onemorning.com">hello&#64;onemorning.com</a>.</li>
						<li><b>Be a Reminder:</b> If you hear someone talking about challenges at work or in life, remind them that resources are available. Sometimes, just knowing someone cares can make a huge difference.</li>
						<li><b>Open Up:</b> Don’t be afraid to talk openly about mental health. The more we normalize these conversations, the more we can break down the barriers that keep people from seeking support.</li>
					</ul>
				</app-faq>
			</li>
			<li>
				<app-faq [question]="'What if my EAP isn\'t responsive or not working for me or my family?'" [index]="5">
					<p><b>Help us, help you-  Email us at <a href="mailto:hello@onemorning.com">hello&#64;onemorning.com</a></b>  Tell us your experience so we tell your organization, we can't change what we don't know.  We care about you and your family.</p>
				</app-faq>
			</li>
		</ul>
		<div class="contact-info" *ngIf="content[5] as data">
			<ng-container *ngIf="data['Phone Number'] || data['Email']">
				<h5>Contact your EAP for more info</h5>
				<ul>
					<li class="phone" *ngIf="data['Phone Number']">{{ data["Phone Number"] | phone }}</li>
					<li class="email" *ngIf="data['Email']">{{ data["Email"] }}</li>
				</ul>
			</ng-container>
		</div>
	</section>

	<section class="outro">
		<p class="fade-in">Find <em>your</em> way back to you.       </p>
	</section>
</div>